import { Box, Icon, Tag, TagCloseButton, TagLabel, WrapItem } from "components";
import { IEmailWithTeam } from "./useValidateEmails";
import { memo, useMemo } from "react";
import { theme } from "@ovou-inc/ovou-ui";
import { tokens } from "@ovou-inc/ovou-ui/tokens";

interface IEmailChipProps extends IEmailWithTeam {
  currentTeamId: number;
  onClose: (email: string) => void;
}

export const EmailChip = memo(function EmailChip({
  email,
  status,
  teamId,
  currentTeamId,
  onClose,
}: IEmailChipProps) {
  const emailStatus = useMemo(() => {
    return status === "success" && teamId
      ? teamId === currentTeamId
        ? "alreadyExists"
        : "alreadyInAnotherTeam"
      : "valid";
  }, [status, teamId, currentTeamId]);

  const handleClose = () => {
    onClose(email);
  };

  return (
    <WrapItem>
      <Tag
        borderRadius="md"
        variant="outline"
        color={theme.palette.ui.blackShades.black}
        paddingY={2}
        border={`1px solid ${
          emailStatus === "valid"
            ? theme.palette.ui.greys.grey3
            : tokens.color.feedback.error
        }`}
        fontSize="14px"
        fontWeight="600"
        height={10}
      >
        {emailStatus !== "valid" && (
          <Box color={tokens.color.feedback.error} marginRight={1}>
            <Icon
              name={emailStatus === "alreadyExists" ? "confirmed" : "groups"}
              width={6}
              height={6}
            />
          </Box>
        )}
        <TagLabel marginRight={2} marginLeft={1}>
          {email}
        </TagLabel>
        <TagCloseButton
          marginX={0}
          boxSize={4}
          color={theme.palette.ui.greys.grey2}
          onClick={handleClose}
        />
      </Tag>
    </WrapItem>
  );
});
